export const getAdjustedItemCountByLimit = (nbItems = 0, limit = 0): number =>
    limit && nbItems > limit ? limit : nbItems;
